import React, { useState } from 'react'
import { useTranslation } from 'gatsby-plugin-react-i18next'

import * as styles from './styles.module.scss'
import { animated, useTransition } from 'react-spring'
import InView from 'react-intersection-observer'

interface Item {
	title: string
	logo: string
	url: string
}

const _items: Item[] = [
	{
		title: 'International E-commerce Summit',
		url: 'https://www.ecommercesummit.cz/autumn-masika-17741',
		logo: '/2021/images/conferences/intl-ecommerce-summit.jpg'
	},
	{
		title: 'Retail Summit Quant',
		url: 'https://www.retail21.cz/cs/program/2021',
		logo: '/2021/images/conferences/retail-summit.png'
	},
	{
		title: 'Email evolution Conference',
		url: 'https://www.ana.net/content/show/id/ms-dmaee-may21',
		logo: '/2021/images/conferences/email-evolution-conference.png'
	},
	{
		title: 'Popai',
		url: 'http://www.popai.cz/',
		logo: '/2021/images/conferences/popai.svg'
	},
	{
		title: 'WOF Expo',
		url: 'http://wofexpo.com/',
		logo: '/2021/images/conferences/wof-expo.png'
	},
	{
		title: 'Shopcamp',
		url: 'https://www.shopcamp.cz/',
		logo: '/2021/images/conferences/shopcamp.jpeg'
	}
]

const Conferences: React.FC = () => {
	const { t } = useTranslation()

	const [items, setItems] = useState<Item[]>([])

	const transitions = useTransition(items, {
		from: { opacity: 0 },
		enter: { opacity: 1 },
		delay: 1000,
		trail: 200
	})

	return (
		<section>
			<div className="container">
				<h2 className="text-center mt-7 mb-6">{t('conferences.title')}</h2>
				<InView onChange={(inView) => inView && setItems(_items)}>
					<div className="text-center">
						{transitions((style, item) => (
							<animated.a href={item.url} target="_blank" style={style}>
								<img
									src={item.logo}
									alt={item.title}
									title={item.title}
									className={styles.logo}
								/>
							</animated.a>
						))}
					</div>
				</InView>
			</div>
		</section>
	)
}

export default Conferences
